import PropTypes from 'prop-types'
import { memo } from 'react'
import styles from './Body.module.scss'

/**
 * The Tooltip `Body`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Body (props) {
  const { children } = props

  return <div className={styles.body}>{children}</div>
}

/** @type {object} */
Body.propTypes = {
  children: PropTypes.node
}

/** @type {object} */
Body.defaultProps = {
  children: null
}

// Memoize
export default memo(Body)
